import React from "react";
import Header from "./Header";

const HomePage = () => {
  return (
    <>
      <Header />
    </>
  );
};

export default HomePage;
